<template>
  <div>  
  <ul class="mb-0" style="margin-top:7px; list-style-type: none;">
    <li
      v-for="(item, value, index) in summary_data"
      :key="index"
      >
      <strong :class="`mr-2 text-primary fa fa-fw ${items[index]}`" />    
      <span style="font-weight: bold;">
          {{value}}
      </span>
      <span>
        : {{item}}
      </span> 
     
      
     
    </li>
  </ul>
  </div>
</template>

<script>
  export default {
    name: 'CollectionSummary',

    props: {
      profile: Object,
      items: Array,
      summary_data: Object
    },

    methods: {
      value({key, format}) {
        const slug = this.mapping[key];
        const rawValue = slug ? this.profile[slug] : undefined;
        return format && rawValue ? format(rawValue) : rawValue;
      }
    },

    computed: {
      mapping() {
        const file = this.$store.getters.getActiveFile('customers');
        const mapping = file && file.entityMap;
        return mapping ? mapping : {};
      }
    }
  };
</script>

<style scoped>

</style>
